"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bson_objectid_1 = __importDefault(require("bson-objectid"));
const path_1 = __importDefault(require("path"));
const tools_defaults_1 = require("./tools-defaults");
const migrate_visualizations_1 = __importDefault(require("./migrate-visualizations"));
const MathUtils = __importStar(require("../utils/math"));
const DefaultPauseTime = 5000;
function getAnnotationsFromEvents(events, fieldAspectRatioInv) {
    for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        if (!event.visualizations || !event.visualizations.length) {
            continue;
        }
        let annotationIndex = 0;
        const explicitPauseTimes = [];
        const implicitPauseTimes = [];
        const annotationsData = event.visualizations.map(visualization => {
            let toolId = visualization.tool_id;
            if (toolId === 'players') {
                toolId = tools_defaults_1.tools.player.id;
            }
            else if (toolId === 'trails') {
                toolId = tools_defaults_1.tools.trail.id;
            }
            else if (toolId === 'futureTrails') {
                toolId = tools_defaults_1.tools.futureTrail.id;
            }
            else if (toolId === 'magnifiers') {
                toolId = tools_defaults_1.tools.magnifier.id;
            }
            else if (toolId === 'line3d') {
                toolId = tools_defaults_1.tools.arrow.id;
            }
            migrate_visualizations_1.default(visualization, toolId);
            const is3d = visualization.options && visualization.options.is3d;
            try {
                if (visualization.start_time === undefined || visualization.start_time === null) {
                    throw new Error('Start time is not defined');
                }
                let oneFrame = visualization.start_time === visualization.end_time;
                let toolData = {};
                if (visualization.end_time === undefined || visualization.end_time === null) {
                    visualization.end_time = visualization.start_time + 1000;
                }
                if (toolId === tools_defaults_1.tools.player.id) {
                    toolData = parsePlayerViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.trail.id) {
                    toolData = parseTrailViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.futureTrail.id) {
                    toolData = parseFutureTrailViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.magnifier.id) {
                    toolData = parseMagnifierViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.measurer.id) {
                    toolData = parseMeasurerViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.teamSize.id) {
                    toolData = parseTeamSizeViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.tacticalLines.id) {
                    toolData = parseTacticalLineViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.freehand.id) {
                    oneFrame = !visualization.options.pinned;
                    toolData = parseFreehandViz(visualization, is3d, fieldAspectRatioInv);
                }
                else if (toolId === tools_defaults_1.tools.circle.id) {
                    oneFrame = !visualization.options.pinned;
                    toolData = parseCircleViz(visualization, is3d, fieldAspectRatioInv);
                }
                else if (toolId === tools_defaults_1.tools.shape.id) {
                    oneFrame = !visualization.options.pinned;
                    toolData = parseShapeViz(visualization, is3d, fieldAspectRatioInv);
                }
                else if (toolId === tools_defaults_1.tools.arrow.id) {
                    oneFrame = !visualization.options.pinned;
                    toolData = parseArrowViz(visualization, is3d, fieldAspectRatioInv);
                }
                else if (toolId === tools_defaults_1.tools.dragger.id) {
                    oneFrame = true;
                    toolData = parseDraggerViz(visualization);
                }
                else if (toolId === tools_defaults_1.tools.pause.id) {
                    oneFrame = true;
                }
                else if (toolId === tools_defaults_1.tools.textBox.id) {
                    toolData = parseTextBoxViz(visualization, is3d, fieldAspectRatioInv);
                }
                else if (toolId === tools_defaults_1.tools.image.id) {
                    toolData = parseImageViz(visualization, is3d, fieldAspectRatioInv);
                }
                else if (toolId === tools_defaults_1.tools.chromaKey.id) {
                    toolData = parseChromaKeyViz(visualization);
                }
                else {
                    throw new Error(`Unknown tool ID '${toolId}'`);
                }
                // Save pause times to be created later if needed.
                if (toolId === tools_defaults_1.tools.pause.id) {
                    explicitPauseTimes.push(visualization.start_time);
                }
                else if (oneFrame &&
                    toolId !== tools_defaults_1.tools.pause.id &&
                    !implicitPauseTimes.includes(visualization.start_time)) {
                    implicitPauseTimes.push(visualization.start_time);
                }
                if (toolData) {
                    const commonData = getCommonFields(event, visualization, annotationIndex, toolId, oneFrame);
                    annotationIndex += 1;
                    return Object.assign(Object.assign({}, commonData), { tool_data: toolData });
                }
            }
            catch (error) {
                console.log('Error on Annotation From Event %s', JSON.stringify(event));
            }
            return undefined;
        });
        // Wait for tool data of all visualizations.
        const annotations = annotationsData.reduce((a, v) => {
            if (v) {
                a[v.annotation_id] = v;
            }
            return a;
        }, {});
        // Create pause annotations when there's no explicit one.
        implicitPauseTimes.forEach(pauseTime => {
            if (!explicitPauseTimes.includes(pauseTime)) {
                const v = { start_time: pauseTime };
                const pauseData = getCommonFields(event, v, annotationIndex, tools_defaults_1.tools.pause.id, true);
                annotationIndex += 1;
                annotations[pauseData.annotation_id] = pauseData;
            }
        });
        event.annotations = Object.values(annotations);
        event.visualizations = [];
    }
    return events.map(event => event.annotations || []);
}
function getCommonFields(e, v, index, toolId, oneFrame) {
    const vStartTime = MathUtils.clamp(v.start_time, e.start_time, e.end_time);
    const vEndTime = MathUtils.clamp(v.end_time, e.start_time, e.end_time);
    const aStartTime = vStartTime;
    const aEndTime = vEndTime;
    const annotation = {
        tool_id: toolId,
        annotation_id: bson_objectid_1.default().toHexString(),
        start_time: aStartTime,
        end_time: aEndTime,
        local_position: index
    };
    if (toolId === tools_defaults_1.tools.pause.id) {
        annotation.should_pause = true;
        annotation.pause_time = v.pause_time || DefaultPauseTime;
    }
    return annotation;
}
function parsePlayerViz(v) {
    if (!v.players || !v.players.length) {
        throw new Error('There is no players defined');
    }
    return {
        displayedPlayers: v.players.reduce((pl, p) => {
            pl[p] = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.player.options), v.options), { uid: p });
            clampToLimits(pl[p], tools_defaults_1.tools.player.limits);
            return pl;
        }, {})
    };
}
function parseTrailViz(v) {
    if (!v.players || !v.players.length) {
        throw new Error('There is no players defined');
    }
    return {
        displayedTrails: v.players.reduce((pl, p) => {
            pl[p] = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.trail.options), v.options), { uid: p });
            clampToLimits(pl[p], tools_defaults_1.tools.trail.limits);
            return pl;
        }, {})
    };
}
function parseFutureTrailViz(v) {
    if (!v.players || !v.players.length) {
        throw new Error('There is no players defined');
    }
    return {
        displayedFutureTrails: v.players.reduce((pl, p) => {
            pl[p] = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.futureTrail.options), v.options), { uid: p });
            clampToLimits(pl[p], tools_defaults_1.tools.futureTrail.limits);
            return pl;
        }, {})
    };
}
function parseMagnifierViz(v) {
    if (!v.players || !v.players.length) {
        throw new Error('There is no players defined');
    }
    return {
        displayedMagnifiers: v.players.reduce((pl, p) => {
            pl[p] = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.magnifier.options), v.options), { uid: p });
            clampToLimits(pl[p], tools_defaults_1.tools.magnifier.limits);
            return pl;
        }, {})
    };
}
function parseMeasurerViz(v) {
    if (!v.players || !v.players.length) {
        throw new Error('There is no players defined');
    }
    // Compatibility with previous API.
    if (v.options && v.options.showDistances !== undefined) {
        v.options.distance = v.options.showDistances;
        delete v.options.showDistances;
    }
    const measurer = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.measurer.options), v.options), { players: v.players.slice(0) });
    clampToLimits(measurer, tools_defaults_1.tools.measurer.limits);
    const measurerId = `measurer_${bson_objectid_1.default().toHexString()}`;
    return {
        displayedMeasurers: {
            [measurerId]: measurer
        }
    };
}
function parseTeamSizeViz(v) {
    if (!v.team) {
        throw new Error('Team is not defined');
    }
    if (!v.line) {
        throw new Error('Line type is not defined');
    }
    if (!['width', 'length'].includes(v.line)) {
        throw new Error(`Line ${v.line} is unknown`);
    }
    const teamSizeId = `teamsize_${bson_objectid_1.default().toHexString()}`;
    const teamSize = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.teamSize.options), v.options), { teamId: v.team, line: v.line });
    clampToLimits(teamSize, tools_defaults_1.tools.teamSize.limits);
    return {
        displayedTeamSizes: {
            [teamSizeId]: teamSize
        }
    };
}
function parseTacticalLineViz(v) {
    if (!v.team) {
        throw new Error('Team is not defined');
    }
    if (!v.line) {
        throw new Error('Line type is not defined');
    }
    if (!['defenders', 'midfielders', 'strikers'].includes(v.line)) {
        throw new Error(`Line ${v.line} is unknown`);
    }
    const tacticalLineId = `tacticalline_${bson_objectid_1.default().toHexString()}`;
    const tacticalLine = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.tacticalLines.options), v.options), { teamId: v.team, line: v.line });
    clampToLimits(tacticalLine, tools_defaults_1.tools.tacticalLines.limits);
    return {
        displayedTacticalLines: {
            [tacticalLineId]: tacticalLine
        }
    };
}
function parseFreehandViz(v, is3d, fieldAspectRatioInv) {
    if (!v.points || !v.points.length) {
        throw new Error('Points are not defined');
    }
    v.points.forEach((p) => checkPointDefinition(p, is3d, fieldAspectRatioInv));
    const freehandId = `freehandline_${bson_objectid_1.default().toHexString()}`;
    const freehand = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.freehand.options), v.options), { points: v.points });
    // Add them if 'continuous' exists.
    if (v.options.continuous !== undefined) {
        freehand.continuous = v.options.continuous;
        freehand.dotted = !v.options.continuous;
    }
    clampToLimits(freehand, tools_defaults_1.tools.freehand.limits);
    return {
        pinned: !!v.options.pinned,
        displayedFreehandLines: {
            [freehandId]: freehand
        }
    };
}
function parseCircleViz(v, is3d, fieldAspectRatioInv) {
    checkPointDefinition(v.center, is3d, fieldAspectRatioInv);
    checkPointDefinition(v.radius);
    const circleId = `circle_${bson_objectid_1.default().toHexString()}`;
    const circle = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.circle.options), v.options), { center: v.center, radius: v.radius });
    // Add them if 'filled' exists.
    if (v.options.filled !== undefined) {
        circle.filled = v.options.filled;
        circle.notFilled = !v.options.filled;
    }
    clampToLimits(circle, tools_defaults_1.tools.circle.limits);
    return {
        pinned: !!v.options.pinned,
        displayedCircles: {
            [circleId]: circle
        }
    };
}
function parseShapeViz(v, is3d, fieldAspectRatioInv) {
    if (!v.points || !v.points.length) {
        throw new Error('Points are not defined');
    }
    v.points.forEach((p) => checkPointDefinition(p, is3d, fieldAspectRatioInv));
    const shapeId = `shape_${bson_objectid_1.default().toHexString()}`;
    const shape = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.shape.options), v.options), { points: v.points });
    // Add them if 'filled' exists.
    if (v.options.filled !== undefined) {
        shape.filled = v.options.filled;
        shape.notFilled = !v.options.filled;
    }
    clampToLimits(shape, tools_defaults_1.tools.shape.limits);
    return {
        pinned: !!v.options.pinned,
        displayedShapes: {
            [shapeId]: shape
        }
    };
}
function parseArrowViz(v, is3d, fieldAspectRatioInv) {
    if (!v.points) {
        throw new Error('Points are not defined');
    }
    checkPointDefinition(v.points.start, is3d, fieldAspectRatioInv);
    checkPointDefinition(v.points.end, is3d, fieldAspectRatioInv);
    const arrowId = `arrow_${bson_objectid_1.default().toHexString()}`;
    const arrow = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.arrow.options), v.options), { points: v.points });
    // Add them if 'continuous' exists.
    if (v.options.continuous !== undefined) {
        arrow.continuous = v.options.continuous;
        arrow.dotted = !v.options.continuous;
    }
    clampToLimits(arrow, tools_defaults_1.tools.arrow.limits);
    return {
        pinned: !!v.options.pinned,
        displayedArrows: {
            [arrowId]: arrow
        }
    };
}
function parseDraggerViz(v) {
    if (!v.points) {
        throw new Error('Points are not defined');
    }
    checkPointDefinition(v.points.start);
    checkPointDefinition(v.points.end);
    const draggerId = `dragger_${bson_objectid_1.default().toHexString()}`;
    const dragger = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.dragger.options), v.options), { points: v.points });
    clampToLimits(dragger, tools_defaults_1.tools.dragger.limits);
    return {
        displayedDraggers: {
            [draggerId]: dragger
        }
    };
}
function parseTextBoxViz(v, is3d, fieldAspectRatioInv) {
    if (!v.text) {
        throw new Error('Text is not defined');
    }
    checkPointDefinition(v.position, is3d, fieldAspectRatioInv);
    if (v.position) {
        const textBox = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.textBox.options), v.options), { text: v.text, x: v.position.x, y: v.position.y });
        clampToLimits(textBox, tools_defaults_1.tools.textBox.limits);
        return textBox;
    }
    return undefined;
}
// Image file must be located in 'images' folder of the workspace.
function parseImageViz(v, is3d, fieldAspectRatioInv) {
    if (!v.url) {
        throw new Error('URL is not defined');
    }
    checkPointDefinition(v.position, is3d, fieldAspectRatioInv);
    checkPointDefinition(v.scale);
    // Read URL.
    const ext = path_1.default.extname(v.url) || '.jpg';
    const fileName = `${path_1.default.basename(v.url, ext)}_${bson_objectid_1.default().toHexString()}${ext}`;
    // TODO: ...
    if (v.position && v.scale) {
        const image = Object.assign(Object.assign(Object.assign({}, tools_defaults_1.tools.image.options), v.options), { localPath: fileName, url: v.url, x: v.position.x, y: v.position.y, scaleX: v.scale.x, scaleY: v.scale.y });
        clampToLimits(image, tools_defaults_1.tools.image.limits);
        return image;
    }
    return undefined;
}
function parseChromaKeyViz(v) {
    const chromaKey = Object.assign(Object.assign({}, tools_defaults_1.tools.chromaKey.options), v.options);
    clampToLimits(chromaKey, tools_defaults_1.tools.chromaKey.limits);
    return chromaKey;
}
function clampToLimits(options, limits) {
    if (!limits) {
        return;
    }
    Object.keys(limits).forEach((id) => {
        const limit = limits[id];
        const option = options[id];
        if (limit.min !== undefined && limit.max !== undefined) {
            options[id] = MathUtils.clamp(option, limit.min, limit.max);
        }
        else if (limit.min !== undefined) {
            options[id] = Math.max(option, limit.min);
        }
        else if (limit.max !== undefined) {
            options[id] = Math.min(option, limit.max);
        }
    });
}
function checkPointDefinition(point, is3d, fieldAspectRatioInv) {
    if (!point) {
        throw new Error('A point is not defined');
    }
    if (point.x === undefined || point.x === null) {
        throw new Error('Coordinate X of a point is not defined');
    }
    if (point.y === undefined || point.y === null) {
        throw new Error('Coordinate Y of a point is not defined');
    }
    if (is3d && fieldAspectRatioInv) {
        point.y *= fieldAspectRatioInv;
    }
}
exports.default = getAnnotationsFromEvents;
